import { connect, no_render } from 'core'
import * as selectors from 'selectors';
import GroupTasks from 'comp/right/group_task';

const mapToProps = state => {
  const conv_id = state.ui.selected_group;
  if(!conv_id){
    return no_render
  }
  const group = selectors.getSelectedGroup(conv_id);
  const tasks = selectors.objToArray(state, 'group', conv_id, 'tasks');
  const submissions = selectors.nullInPath(state, 'group', conv_id, 'submissions');
  return {
    jumping:state.ui.jump_to_conv,
    is_admin: group.is_admin,
    tasks,
    conv_id,
    total_partic: group.total_partic,
    submissions,
    submit_status: state.fetch.group_submit,
    submisions_uploads: state.uploader.submissions
  };
};

export default connect(GroupTasks,mapToProps);



// WEBPACK FOOTER //
// ./src/containers/right/GroupTask.js